import { useSelector } from 'react-redux';
import RoomCascadeButton from './components/web/RoomCascadeButton';
import { USER_FUNCTIONS } from '../user/constant';
import { checkHaveFunctionCode } from '../user/functions';
const roomCascade = {
    key: 'roomcascade',
    Content: RoomCascadeButton,
    group: 2
};
/**
 * A hook that returns the whiteboard button if it is enabled and undefined otherwise.
 *
 *  @returns {Object | undefined}
 */
export function useRoomCascadeButton() {
    const _isRoomCascadeButtonVisible = useSelector((state) => checkHaveFunctionCode(state, USER_FUNCTIONS.CASCADE_CONNECTION_LIMIT));
    if (_isRoomCascadeButtonVisible) {
        return roomCascade;
    }
}
